import clsx from "clsx";

type TestimonialCardProps = {
	className?: string;
	children?: React.ReactNode;
	fillColor?: string;
	specialTestimonial?: boolean;
};

export default function TestimonialCard({ className, children, fillColor, specialTestimonial = false }: TestimonialCardProps) {
	return (
		<div className={clsx("relative grid grid-rows-[1fr_auto] overflow-hidden", className)}>
			{/* Upper row - rectangle background with content */}
			<div
				className={clsx(
					"relative z-10 h-full rounded-tl-[0.625rem] rounded-tr-[0.625rem] rounded-br-md pt-6 pr-6 pl-6 text-white",
					specialTestimonial ? "bg-navy-blue-deep" : "bg-white",
				)}
			>
				{children}
			</div>

			{/* Lower row - curved SVG shape */}
			<div className="relative -mt-1 h-16 w-full overflow-hidden">
				<svg className="absolute inset-0 h-full w-full" viewBox="0 294 382 68" fill="none" preserveAspectRatio="none">
					<path
						d="M7.41049 361.484C3.43422 361.484 0.210738 358.261 0.210491 354.285L0.195304 109.556L0.195297 8.08749C0.195297 4.11105 3.41885 0.887512 7.3953 0.887512L54.8757 0.88751L374.596 0.887526C378.572 0.887526 381.795 4.11082 381.796 8.08714L381.811 294.647C381.811 296.476 381.114 298.237 379.863 299.572L323.944 359.209C322.583 360.661 320.682 361.484 318.692 361.484L28.1681 361.484L7.41049 361.484Z"
						fill={fillColor}
					/>
				</svg>
			</div>
		</div>
	);
}
